/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React, {Component, PropTypes} from 'react';
import {
  FormGroup,
  Container,
  Input,
  Label,
  Button,
  Col,
  Modal,
  ModalHeader,
  ModalFooter
} from '../../Common/reactstrap/lib';
import Checkbox from 'src/components/Checkbox/Checkbox';
class ModalEmails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.email
    };
    this.submit = this.submit.bind(this);
  }

  submit() {
console.log(this.props.userId);
    const isDataValid = (this.state.email);
    if (isDataValid) {
      this.props.updateEmail([{...this.state}]);
      this.props.close();
    }
    else {
      alert('Пустые поля не заполнены! ');
    }
  }

  render() {


    return (
      <Modal isOpen={this.props.visible} toggle={this.props.close} className={this.props.className}>
        <ModalHeader toggle={this.props.close}>Email</ModalHeader>
        <Container>
          <FormGroup row>
            <Col sm={12} className="mb-3">
              <Input type="text" placeholder="email" value={this.state.email || ''}
                     onChange={(e) => this.setState({
                     email: e.target.value})}
                     />
            </Col>
            <Col sm={4}>
              <Checkbox
                text={`Для документов`}
                name="forDocuments"
                checked={this.state.forDocuments}
                onChange={() =>
                  this.setState({
                    forDocuments: !this.state.forDocuments
                  })}
              /></Col>
            <Col sm={6}>
              <Checkbox
                text={`Уведомления по заказам`}
                name="forOrders"
                checked={this.state.forOrders}
                onChange={() =>
                  this.setState({
                    forOrders: !this.state.forOrders
                  })}
              />
            </Col>
          </FormGroup>
        </Container>

        <ModalFooter>
          <Button onClick={this.submit}>Сохранить</Button>
        </ModalFooter>
      </Modal>
    );
  }

}

ModalEmails.propTypes = {
  isOpen: PropTypes.bool,

  toggle: PropTypes.func,

  size: PropTypes.string,

  backdrop: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.oneOf(['static'])
  ]),
  keyboard: PropTypes.bool,

  zIndex: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
};

export default ModalEmails;



/** WEBPACK FOOTER **
 ** ./src/components/User/elements/ModalEmails.jsx
 **/